import { useState } from "react";
import styles from "../styles.module.css";
import SurveyOptionItem from "./SurveyOptionItem";
import { Button } from "antd";
import useSurvey from "../../../pages/surveys/hooks/useSurvey";
import ConditionalItem from "./ConditionalItem";

const OptionsTypeSurvey = ({
  options,
  surveyId,
  question,
  showConditional,
  showRating,
}) => {
  const [isCreating, setIsCreating] = useState(false);
  const { createNewQuestionOption, getSurveyInfo } = useSurvey();

  const handleCreateNewQuestionOption = async () => {
    setIsCreating(true);
    const res = await createNewQuestionOption(question.id);
    if (res) {
      await getSurveyInfo(Number(surveyId));
    }
    setIsCreating(false);
  };

  return (
    <div className={` ${styles["survey-question-options-list"]}`}>
      {options.map((option, index) => (
        <div
          className={`${
            !showConditional
              ? styles["options-without-conditionals"]
              : styles["options-with-conditionals"]
          }`}
          key={option.id_question_option}
        >
          <SurveyOptionItem
            showRating={showRating}
            surveyId={surveyId}
            option={option}
            index={index}
          />
          {!!showConditional && (
            <ConditionalItem
              option={option}
              index={index}
              question={question}
              surveyId={surveyId}
            />
          )}
        </div>
      ))}

      {(!showRating || (showRating && options.length < 5)) && (
        <div
          className={`${styles["add-new-option-btn"]} 
      ${
        !showConditional
          ? styles["options-without-conditionals--btn"]
          : styles["options-with-conditionals--btn"]
      }
      `}
        >
          <Button loading={isCreating} onClick={handleCreateNewQuestionOption}>
            + Añadir opción
          </Button>
        </div>
      )}
    </div>
  );
};

export default OptionsTypeSurvey;
